/**
 * Swiper is loaded as a registered WordPress script dependency (handle
 * `swiper`, see leopolis_register_vendor_assets() /
 * leopolis_add_swiper_block_dependencies() in the main plugin file), not
 * bundled here. It's available as the global `Swiper`, with every module
 * (Navigation, Pagination, etc.) already installed by the bundle build,
 * so there's no `modules` array to pass in.
 */
document.addEventListener("DOMContentLoaded", () => {
	if (typeof Swiper === "undefined") {
		return;
	}

	const sliders = document.querySelectorAll(
		".wp-block-leopolis-product-categories-slider__swiper",
	);

	sliders.forEach((sliderEl) => {
		const root = sliderEl.closest(
			".wp-block-leopolis-product-categories-slider",
		);

		const paginationEl = sliderEl.querySelector(".swiper-pagination");

		new Swiper(sliderEl, {
			slidesPerView: 1,
			spaceBetween: 24,
			scrollbar: {
				el: ".swiper-scrollbar",
				draggable: true,
			},
			autoplay: true,
			breakpoints: {
				640: { slidesPerView: 2 },
				1024: { slidesPerView: 3 },
				1280: { slidesPerView: 4 },
			},
		});
	});
});
